var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-network-cable-calculator t-margin-bottom-s" },
    [
      _c("div", { staticClass: "o-grid" }, [
        _c(
          "div",
          {
            staticClass: "o-grid__column",
            attrs: { "data-size": "sm:12 md:9 lg:9" }
          },
          [
            _c("fieldset", { staticClass: "t-margin-bottom-m" }, [
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("dropdown-variations", {
                    ref: "cableOptions",
                    attrs: {
                      "item-groups": _vm.cableOptions,
                      label: "Kabel",
                      required: false,
                      "input-id": "cableOptions"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("vue-input", {
                    ref: "ambientTemp",
                    attrs: {
                      label: "Omgivningstemp (Tambient) i °C",
                      "input-id": "ambientTemp",
                      required: false,
                      "text-input-should-behave-as-number": true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("vue-input", {
                    ref: "cableBundleSize",
                    attrs: {
                      label: "Kabelbuntstorlek (N) i st här",
                      "input-id": "cableBundleSize",
                      required: false,
                      "no-decimal": true,
                      "text-input-should-behave-as-number": true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("dropdown-variations", {
                    ref: "installationMethod",
                    attrs: {
                      "item-groups": _vm.installationMethod,
                      label: "Installationsmetod",
                      required: false,
                      "input-id": "installationMethod"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("vue-input", {
                    attrs: {
                      label: "Temperatur ökning i kabelbunt (ΔT) i °C",
                      "input-id": "temperatureIncrease",
                      value: _vm.temperatureIncrease,
                      type: "text",
                      required: false,
                      readonly: true
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("fieldset", [
              _c(
                "div",
                { staticClass: "t-margin-bottom-m" },
                [
                  _c("dropdown-variations", {
                    ref: "totalCableLength",
                    attrs: {
                      "item-groups": _vm.totalCableLength,
                      label: "Total kablagelängd (Lcord) i m",
                      required: false,
                      "input-id": "totalCableLength"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "c-network-cable-calculator__extra--label" },
                    [_vm._v("Korskopplings- & anslutnings-kablage")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("vue-input", {
                    attrs: {
                      label: "Temperatur (Tglobal) i °C",
                      "input-id": "temperature",
                      value: _vm.temperature,
                      type: "text",
                      required: false,
                      readonly: true,
                      "css-classes":
                        _vm.temperature > 60
                          ? "c-network-cable-calculator__indication"
                          : ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__item" },
                [
                  _c("vue-input", {
                    attrs: {
                      label: "Längd på Permanent Länk (L) i m",
                      "input-id": "lengthPermanentLink",
                      value: _vm.lengthPermanentLink,
                      type: "number",
                      required: false,
                      readonly: true,
                      "css-classes":
                        _vm.lengthPermanentLink > 100
                          ? "c-network-cable-calculator__indication"
                          : ""
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.errorText.length > 0
              ? _c("div", { staticClass: "t-margin-bottom-s" }, [
                  _c(
                    "p",
                    { staticClass: "c-network-cable-calculator__error" },
                    [_vm._v(_vm._s(_vm.errorText))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "t-text-align-right" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--primary",
                  attrs: { type: "button" },
                  on: { click: _vm.updateValues }
                },
                [_vm._v("Räkna")]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }